import React, { MouseEvent } from 'react';
import { useCurrentLocale } from '../../src/contexts/CurrentLanguageContext';
import { fetchPost } from '../../src/utils/fetchWrapper';
import { FulltextHits, FulltextHitsProps } from './FulltextHits'
import { FulltextSearchBox } from './FulltextSearchBox'



export const HomepageSearch: React.FC = () => {
	const locale = useCurrentLocale();
	const [queryString, setQueryString] = React.useState<string>('');
	const [data, setData] = React.useState<FulltextHitsProps | null>(null);

	React.useEffect(() => {

		if(queryString.length >= 3)
		{
			(fetchPost('/fulltext/autocomplete?' + new URLSearchParams({q: queryString, locale: locale})) as Promise<FulltextHitsProps>)
			.then(res => setData(res));
		}
		else 
		{
			setData(null);
		}

	}, [queryString]);

	const onHitClick = (e : MouseEvent<HTMLAnchorElement>) => {
		setQueryString('');
	};

	const onBlur = () => {
		setTimeout(() => {
			setQueryString('');
		}, 100);
	};

	const ref = React.useRef<HTMLDivElement>(null);
	React.useEffect(() => {

		const clickHandler = (e : Event) => {
			if(ref.current && ref.current.contains(e.target as Node)) {
				return;
			}

			setQueryString('');
		}

		if(queryString.length >= 3)
		{
			window.addEventListener('click', clickHandler);
		}
		
		return () => {
			window.removeEventListener('click', clickHandler);
		}
	}, [queryString, setQueryString, ref.current]);

	return (
		<div className="homepageSearch" ref={ref} >
				<FulltextSearchBox onSubmit={onBlur} queryString={queryString} setQueryString={setQueryString} />
				<div className="homepageSearch-hits" onBlur={onBlur} onClick={onBlur}>
					{
						data && <FulltextHits onHitClick={onHitClick} {...data} />
					}
				</div>
		</div>
	)
}
